module.exports = __webpack_public_path__ + "img/img_1.943756b0.png";